import React from "react";
import searcher from "../../assets/icons/searchInput.svg";
import back from "../../assets/icons/back.svg";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import DistributorVersionTable from "./distributor-version-list-table";

const DistributorVersionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <MainLayout breadCrumb="ADMIN  /  Distributor  / Version History">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="d-flex w-100">
            <div
              className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
              onClick={() => navigate("/distributors/distributor")}
            >
              <img src={back} alt="back_btn" />
              <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                BACK
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} alt="o" />
                <input
                  value={search}
                  className="search-input fs_14 fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search distributors here by distributor ID, distributor name..."
                  onChange={(e) => {
                    navigate(
                      `/distributors/distributor/version-list?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                />
              </div>
              <button
                onClick={() =>
                  navigate(`/distributors/distributor/version-list`)
                }
                className="py-1 border-0 rounded-2 mx-2 m-1 px-3 fs_14 Medium_Purple"
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>
        <DistributorVersionTable
          search={search}
          status={status}
          page_no={page_no}
        />
      </div>
    </MainLayout>
  );
};

export default DistributorVersionList;
